import { useQuery } from "@tanstack/react-query";
import { api } from "@utils/api";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { onboardingQKeys } from "./queryKeys";

export const useGetContractPreview = () => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: [...onboardingQKeys.session(), "contract-preview"],
    queryFn: () => api.get(`onboarding/session/me/contract-preview`),
    select: (res: any) => res.data.html,
    onError: (res: any) => {
      console.error("[From Get Contract Preview]", res);
      handleErrors(res, "query");
    },
  });
};
